export function initZendesk(): void {
  if (import.meta.env.PROD) {
    const scriptZendesk = document.createElement('script');
    scriptZendesk.setAttribute(
      'src',
      'https://static.zdassets.com/ekr/snippet.js?key=bdee766c-8f65-4a08-aad0-d03dae5ce17a',
    );
    scriptZendesk.setAttribute('id', 'ze-snippet');
    document.body.appendChild(scriptZendesk);

    window.addEventListener('load', () => {
      // eslint-disable-next-line no-undef
      zE('messenger', 'hide');

      // eslint-disable-next-line no-undef
      zE('messenger:on', 'open', function () {
        // eslint-disable-next-line no-undef
        zE('messenger', 'show');
      });

      // eslint-disable-next-line no-undef
      zE('messenger:on', 'close', function () {
        // eslint-disable-next-line no-undef
        zE('messenger', 'hide');
      });
    });
  }
}
